import React from "react";
import "./modal.css";
import PropTypes from "prop-types";

export const Modal = ({
    bodyContent,
    closeModal,
    footerContent,
    isModalOpen,
    modalTitle,
    id
}) => {
    return (
        <div className="c-modal" aria-hidden={!isModalOpen} style={isModalOpen ? {} : {
            display: 'none',
        }}>
            <div className="c-modal__overlay js-modal-close" tabIndex="-1"></div>

            <div className="c-modal__wrapper" aria-labelledby={`foo-bar-baz-${id}`}>
                <header className="c-modal__header">
                    <div className="c-modal__title__wrapper">
                        <h2 className="c-modal__title" id={`foo-bar-baz-${id}`}>{modalTitle}</h2>
                    </div>
                    <button
                        id={`modal-close-button-${id}`}
                        data-test-id={`test-modal-close-button-${id}`}
                        className="c-modal__close-btn  js-modal-close"
                        type="button"
                        aria-label="Close this dialog window."
                        onClick={closeModal}
                    ></button>
                </header>

                <div className="c-modal__content">
                    <div>{bodyContent}</div>
                </div>

                <div className="c-modal__footer">
                    <div className="c-modal__actions">
                        <div className="c-modal__actions__item">
                            {footerContent}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

Modal.propTypes = {
    bodyContent: PropTypes.node,
    closeModal: PropTypes.func.isRequired,
    footerContent: PropTypes.node,
    isModalOpen: PropTypes.bool.isRequired,
    modalTitle: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired
};